<style lang="scss" scoped="scoped">
// ::-webkit-scrollbar {
// 	width: 0 !important
// }
::-webkit-scrollbar {
	display: none;
}

.vue-grid-item {
	background: #202027;
	// overflow: auto;
	box-sizing: border-box;
	position: relative;
}

.vue-grid-item.vue-grid-placeholder {
	background: #419fff !important;
}

.el-dropdown-link {
	cursor: pointer;
	color: #419fff;
}

.bg {
	background: rgb(18, 18, 18);
}

::v-deep .progress-green {
	.el-progress__text {
		color: #39f16d !important;
	}

	.el-progress-bar__outer {
		background-color: #515c69;
	}
}

::v-deep .el-input__inner {
	color: #419fff;
	border: none;
	background-color: transparent;
	text-align: right;
	width: 260px;
}

::v-deep .el-cascader .el-input .el-icon-arrow-down {
	color: #419fff;
}

::v-deep .el-input__inner::-webkit-input-placeholder {
	color: #419fff;
}

// .vue-grid-layout::-webkit-scrollbar {
// 	width: 0 !important
// }

.module-grid {
	background: #202027;
}

::v-deep .product-progress-blue .el-progress__text {
	color: #419FFF !important;
}
</style>
<style lang="scss">
.el-popper {
	margin-right: 10px;
}
</style>

<template>
	<div style="display: inline;">
		<div class="bg" style="position: absolute;height: 100%;width: 100%;box-sizing: border-box;">
			<div ref="header" style="padding: 34px 34px  0px  34px;">
				<div class="module-grid" style="border-radius: 2px;width: 100%;height: 66px;padding:0px 20px;display: flex;justify-content: space-between;align-items: center;">
					<div style="width: 340px;cursor: pointer;"><img @click="utils.event_hub.$emit('TOGGLE_TABBAR', !store.state.is_monitor_full)" style="width: 176px;height: 38px;" src="../../../../assets/img/web/workshop/logo.png" />
					</div>
					<div style="font-weight: 700;font-size: 30px;color: white;">
						{{ store.state.customer.shortName }}-{{ $t('zhiliangfenxi') }}
					</div>
					<div class="monitorQualityAnalysis" style="width: 340px;display: flex;flex-direction: column;justify-content: center;align-items: flex-end;">
						<p style="font-size: 14px;color:white;">{{ store.state.currentTime }}</p>
						<yi_data_select :type="'organization'" :ids.sync="orgId"></yi_data_select>
					</div>
				</div>
			</div>
			<div style="padding: 0px 14px 34px  14px;" v-if="rows">
				<grid-layout v-if="gridContainerHeight != 0" :layout.sync="layout" :col-num="24" :maxRows="24" :row-height="gridRowHeihgt" :is-draggable="false" :is-resizable="false" :is-mirrored="false" :vertical-compact="true" :margin="[20, 20]" :use-css-transforms="true" :style="{ height: gridContainerHeight + 'px' }" style="overflow: auto;">
					<grid-item :refs="'grid_' + item.i" v-for="item in layout" :x="item.x" :y="item.y" :w="item.w" :h="item.h" :i="item.i" :key="item.i">
						<div style="color: white;font-weight: 700;height: 100%;">
							<div v-if="item.i == '1' && rows[0]" style="display: flex;height:100%;align-items: center;justify-content: center;flex-direction: column;">
								<div style="display:flex;align-items: center;">
									<span style="font-size: 18px;">{{ $t('benyue') }}&nbsp;{{ $t('zongtiliangpinlv') }}</span>
									<span style="font-size: 22px;color: #39F16D;margin-left: 6px;">{{ rows[0].thisMonthBestProductsProportion }}%</span>
								</div>
								<div style="display:flex;align-items: center;">
									<span style="font-size: 18px;">{{ $t('huanbi') }}&nbsp;{{ $t('shangyue') }}&nbsp;{{ rows[0].lastMonthBestProductsProportion }}%</span>

									<img v-if="rows[0].thisMonthBestProductsProportion - rows[0].lastMonthBestProductsProportion >= 0" style="width: 63px;height: 32px;" src="../../../../assets/img/web/quality_analysis/up.svg" />
									<img v-if="rows[0].thisMonthBestProductsProportion - rows[0].lastMonthBestProductsProportion < 0" style="width: 63px;height: 32px;" src="../../../../assets/img/web/quality_analysis/down.svg" />
									<span v-if="rows[0].thisMonthBestProductsProportion - rows[0].lastMonthBestProductsProportion >= 0" style="font-size: 22px;color: #39F16D;margin-left: 6px;">{{ (rows[0].thisMonthBestProductsProportion - rows[0].lastMonthBestProductsProportion).toFixed(2) }}%</span>
									<span v-if="rows[0].thisMonthBestProductsProportion - rows[0].lastMonthBestProductsProportion < 0" style="font-size: 22px;color: #FF3A5E;margin-left: 6px;">{{ (rows[0].lastMonthBestProductsProportion - rows[0].thisMonthBestProductsProportion).toFixed(2) }}%</span>

								</div>
							</div>
							<div v-if="item.i == '2'" style="display: flex;height:100%;align-items: center;justify-content: center;flex-direction: column;">
								<div style="display:flex;align-items: center;">
									<span style="font-size: 18px;">{{ $t('benyue') }}&nbsp;{{ $t('shebei') }}&nbsp;</span>
									<span style="font-size: 18px;color: #FF3A5E;">{{ rows[0].thisMonthEquipmentProductsProportion && rows[0].thisMonthEquipmentProductsProportion.name }}&nbsp;</span>
									<span style="font-size: 18px;">{{ $t('liangpinlv') }}</span>
									<span style="font-size: 18px;color: #FF3A5E;">{{ $t('zuidi') }}&nbsp;</span>
									<span style="font-size: 22px;color: #FF3A5E;margin-left: 6px;">{{ rows[0].thisMonthEquipmentProductsProportion && rows[0].thisMonthEquipmentProductsProportion.thismonthequipmentproductsproportion }}%</span>
								</div>
								<div style="display:flex;align-items: center;">
									<span style="font-size: 18px;">{{ $t('shangyue') }}&nbsp;{{ $t('shebei') }}&nbsp;</span>
									<span style="font-size: 18px;color: #FF3A5E;">{{ rows[0].lastMonthEquipmentProductsProportion && rows[0].lastMonthEquipmentProductsProportion.name }}&nbsp;</span>
									<span style="font-size: 18px;">{{ $t('liangpinlv') }}</span>
									<span style="font-size: 18px;color: #FF3A5E;">{{ $t('zuidi') }}&nbsp;</span>
									<span style="font-size: 22px;color: #FF3A5E;margin-left: 6px;">{{ rows[0].lastMonthEquipmentProductsProportion && rows[0].lastMonthEquipmentProductsProportion.lastmonthequipmentproductsproportion }}%</span>
								</div>
							</div>
							<div v-if="item.i == '3'" style="display: flex;height:100%;align-items: center;justify-content: center;flex-direction: column;">
								<div style="display:flex;align-items: center;">
									<span style="font-size: 18px;">{{ $t('benyue') }}&nbsp;{{ $t('buliangyuanyin') }}&nbsp;</span>
									<span style="font-size: 18px;color: #FF3A5E;">{{ rows[0].thisMonthDefectCodeQuantity && rows[0].thisMonthDefectCodeQuantity.desc }}&nbsp;</span>
									<span style="font-size: 18px;">{{ $t('zhanbi') }}</span>
									<span style="font-size: 18px;color: #FF3A5E;">{{ $t('zuigao') }}&nbsp;</span>
									<span style="font-size: 22px;color: #FF3A5E;margin-left: 6px;">{{ rows[0].thisMonthDefectCodeQuantity && rows[0].thisMonthDefectCodeQuantity.thismonthmaxdefectquantity }}%</span>
								</div>
								<div style="display:flex;align-items: center;">
									<span style="font-size: 18px;">{{ $t('shangyue') }}&nbsp;{{ $t('buliangyuanyin') }}&nbsp;</span>
									<span style="font-size: 18px;color: #FF3A5E;">{{ rows[0].lastMonthDefectCodeQuantity && rows[0].lastMonthDefectCodeQuantity.desc }}&nbsp;</span>
									<span style="font-size: 18px;">{{ $t('zhanbi') }}</span>
									<span style="font-size: 18px;color: #FF3A5E;">{{ $t('zuigao') }}&nbsp;</span>
									<span style="font-size: 22px;color: #FF3A5E;margin-left: 6px;">{{ rows[0].lastMonthDefectCodeQuantity && rows[0].lastMonthDefectCodeQuantity.thismonthmaxdefectquantity }}%</span>
								</div>
							</div>
							<div v-if="item.i == '4'" style="display: flex;height:100%;align-items: center;justify-content: center;flex-direction: column;">
								<div style="display:flex;align-items: center;">
									<span style="font-size: 18px;">{{ $t('benyue') }}&nbsp;{{ $t('') }}&nbsp;</span>
									<span style="font-size: 18px;color: #FF3A5E;">{{ rows[0].thisMonthProductProportion && rows[0].thisMonthProductProportion.productcodeandname }}&nbsp;</span>
									<span style="font-size: 18px;">{{ $t('liangpinlv') }}</span>
									<span style="font-size: 18px;color: #FF3A5E;">{{ $t('zuidi') }}&nbsp;</span>
									<span style="font-size: 22px;color: #FF3A5E;margin-left: 6px;">{{ rows[0].thisMonthProductProportion && rows[0].thisMonthProductProportion.productionyield }}%</span>
								</div>
								<div style="display:flex;align-items: center;">
									<span style="font-size: 18px;">{{ $t('shangyue') }}&nbsp;{{ $t('') }}&nbsp;</span>
									<span style="font-size: 18px;color: #FF3A5E;">{{ rows[0].lastMonthProductProportion && rows[0].lastMonthProductProportion.productcodeandname }}&nbsp;</span>
									<span style="font-size: 18px;">{{ $t('liangpinlv') }}</span>
									<span style="font-size: 18px;color: #FF3A5E;">{{ $t('zuidi') }}&nbsp;</span>
									<span style="font-size: 22px;color: #FF3A5E;margin-left: 6px;">{{ rows[0].lastMonthProductProportion && rows[0].lastMonthProductProportion.productionyield }}%</span>
								</div>
							</div>
							<div v-if="item.i == 'lpltj'" style="width: 100%;height: 100%;padding:10px;padding-top:10px;display: flex;flex-direction: column;">
								<div class="titleBar" style="display: flex;align-items:center;flex-shrink: 0;">
									<span style="width: 4px;height: 13px;background: #FFC83A;margin-right:12px;"></span>
									<p style="font-size: 16px;color: #FFFFFF;font-weight: 700;">
										{{ $t('nianliangpinlvqushi') }}
									</p>
								</div>
								<div style="flex: 1;width: 100%;margin-top: 16px;">
									<div ref="chart3" style="width: 100%;height: 100%;" id="MonitorQualityAnalysisChart3"></div>
								</div>
							</div>

							<template v-for="(row, j) in rows">
								<div v-if="j > 0 && j + 4 == parseInt(item.i)" style="width: 100%;height: 100%;padding:20px;padding-top:10px;display: flex;flex-direction: column;">
									<div style="display: flex;flex: 1;margin-top: 10px;">
										<div style="flex: 3;flex-direction: column;display: flex;">
											<div class="titleBar" style="display: flex;align-items:center ;flex-shrink: 0;">
												<span style="width: 4px;height: 13px;background: #39F16D;margin-right:12px ;"></span>
												<p style="font-size: 16px;color: #FFFFFF;font-weight: 700;">
													{{ [$t('zuorishebeiliangpinlv'), $t('benyueshebeiliangpinlv'), $t('shangyueshebeiliangpinlv')][j - 1] }}
												</p>
											</div>
											<div style="flex: 1;display: flex;flex-direction: column;justify-content: space-between;width: 100%;margin-top: 16px;">
												<div style="display: flex;width: 100%;" v-for="k in 5">
													<template v-if="row.equipmentBestProductProportion[k - 1]">
														<div style="color: white;width: 100px;">
															{{ row.equipmentBestProductProportion[k - 1].equipmentName }}
														</div>
														<div style="flex: 1;">
															<el-progress class="progress-green" :color="'#39F16D'" :percentage="row.equipmentBestProductProportion[k - 1].proportion">
															</el-progress>
														</div>
													</template>
												</div>
											</div>
										</div>
										<div style="flex: 4;margin-left: 100px;display: flex;flex-direction: column;">
											<div class="titleBar" style="display: flex;align-items:center ;flex-shrink: 0;">
												<span style="width: 4px;height: 13px;background: #FFC83A;margin-right:12px ;"></span>
												<p style="font-size: 16px;color: #FFFFFF;font-weight: 700;">
													{{ [$t('zuoribuliangyuanyinfenbu'), $t('benyuebuliangyuanyinfenbu'), $t('shangyuebuliangyuanyinfenbu')][j - 1] }}
												</p>
											</div>
											<div ref="chart" style="flex: 1;width: 100%;margin-top: 16px;">
												<div style="width: 100%;overflow: hidden;" :style="{ height: chartHeight + 'px' }" :id="'MonitorQualityAnalysisChart1' + (j - 1)"></div>
											</div>
										</div>
										<div style="flex: 4;margin-left: 100px;">
											<div class="titleBar" style="display: flex;align-items:center ;">
												<span style="width: 4px;height: 13px;background: #419FFF;margin-right:12px ;"></span>
												<p style="font-size: 16px;color: #FFFFFF;font-weight: 700;">
													{{ [$t('zuorichanpinliangpinlv') + 'Top3', $t('benyuechanpinliangpinlv') + 'Top3', $t('shangyuechanpinliangpinlv') + 'Top3'][j - 1] }}
												</p>
											</div>
											<div style="flex: 1;width: 100%;display: flex;flex-direction: column;height: calc(100% - 40px);margin-top: 16px;">
												<div v-for="(item, idx) in (row.bestProductProportion ? row.bestProductProportion.slice(0, 3) : [])" :key="idx" style="display: flex;width: 100%;height: calc(100% / 3);align-items: center;">
													<div style="color: white;width: 180px;">
														{{ item.productCodeAndName }}
													</div>
													<div style="flex: 1;margin-left: 20px;">
														<el-progress class="product-progress-blue" :color="'#419FFF'" :percentage="item.proportion"></el-progress>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</template>
						</div>
					</grid-item>
				</grid-layout>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
import VueGridLayout from 'vue-grid-layout';

export default {
	name: 'web_monitor_quality_analysis_index',
	components: {
		GridLayout: VueGridLayout.GridLayout,
		GridItem: VueGridLayout.GridItem
	},

	data() {
		return {
			rows: null,
			charts1: [],
			charts2: [],
			chart3: null, // 添加年度良品率折线图
			timer: null,
			chartData: [{
				name: '圣彼得堡来客',
				value: 56
			}, {
				name: '陀思妥耶夫斯基全集',
				value: 1
			}, {
				name: '史记精注全译（全6册）',
				value: 8
			}, {
				name: '加德纳艺术通史',
				value: 5
			}, {
				name: '表象与本质',
				value: 5
			}, {
				name: '其它',
				value: 38
			}],
			chartHeight: 0,
			chartWidth: 0,
			orgId: this.store.state.organizations[0].id,
			gridContainerHeight: 0,
			gridRowHeihgt: 0,
			layout: [{
				x: 0,
				y: 0,
				w: 5,
				h: 3.5, //应该是6
				i: '1'
			},
			{
				x: 5,
				y: 0,
				w: 5,
				h: 3.5, //应该是6
				i: '2'
			},
			{
				x: 10,
				y: 0,
				w: 6,
				h: 3.5, //应该是6
				i: '3'
			},
			{
				x: 16,
				y: 0,
				w: 8,
				h: 3.5, //应该是6
				i: '4'
			},
			{
				x: 0,
				y: 3.5,
				w: 24,
				h: 5.5,
				i: 'lpltj'
			},

			{
				x: 0,
				y: 3.5,
				w: 24,
				h: 5,
				i: '5'
			},
			{
				x: 0,
				y: 10.33,
				w: 24,
				h: 5,
				i: '6'
			},
			{
				x: 0,
				y: 17.16,
				w: 24,
				h: 5,
				i: '7'
			}
			]
		};
	},
	watch: {

		'orgId'(newValue, oldValue) {
			if (this.utils.isEqual(newValue, oldValue)) {
				return
			}
			this.getQuality()
		},
	},

	created() {
		this.utils.event_hub.$emit('TOGGLE_TABBAR', true);
		this.timer = setInterval(() => {
			this.getQuality();
		}, 600000);
		this.getQuality();
	},
	activated() {
		this.resize();
	},
	mounted() {
		this.resize();
		this.utils.event_hub.$on('RESIZE', () => {
			this.resize();
		});
	},
	destroyed() {
		if (this.timer) {
			clearInterval(this.timer);
		}
		// 清理图表实例
		if (this.chart3) {
			this.chart3.dispose();
		}
		for (let i = 0; i < this.charts1.length; i++) {
			if (this.charts1[i]) {
				this.charts1[i].dispose();
			}
		}
		for (let i = 0; i < this.charts2.length; i++) {
			if (this.charts2[i]) {
				this.charts2[i].dispose();
			}
		}
	},
	methods: {
		getQuality() {
			console.log(this.orgId);
			this.http
				.get('/web/report/page/quality_analysis', {
					params: {
						orgId: this.orgId
					}
				})
				.then(response => {
					this.rows = response.data.rows;
					setTimeout(() => {
						//12个月良品率

						if (this.rows[4] && this.rows[4].lastOneYearGoodRate) {

							let lastOneYearGoodRate = this.rows[4].lastOneYearGoodRate
							let lastOneYearGoodRateMonths = lastOneYearGoodRate.map(item => item.month)
							let lastOneYearGoodRateValues = lastOneYearGoodRate.map(item => item.goodRate)
							console.log(lastOneYearGoodRateMonths, lastOneYearGoodRateValues)

							// 初始化年度良品率折线图
							if (!this.chart3) {
								this.initChart3();

							}
							// 更新年度良品率折线图数据
							if (this.chart3) {
								this.chart3.setOption({
									xAxis: {
										data: lastOneYearGoodRateMonths
									},
									series: [{
										data: lastOneYearGoodRateValues
									}]
								});
							}
						}

						for (let j = 1; j <= 3; j++) {
							if (!this.rows[j]) continue;
							const chartDom = document.getElementById('MonitorQualityAnalysisChart1' + (j - 1));
							if (!chartDom) {
								console.error('找不到DOM', 'MonitorQualityAnalysisChart1' + (j - 1));
								continue;
							}
							if (!this.charts1[j - 1]) {
								this.initChart1(j - 1);
							}
							let defectCodeDistribution = this.rows[j].defectCodeDistribution || [];
							for (let k = 0; k < defectCodeDistribution.length; k++) {
								defectCodeDistribution[k].name = defectCodeDistribution[k].name + '||' + defectCodeDistribution[k].id;
							}
							this.charts1[j - 1].setOption({
								series: [{
									data: defectCodeDistribution
								}]
							});
						}
					}, 2000);
				});
		},

		initChart1(index) {
			var chartDom = document.getElementById('MonitorQualityAnalysisChart1' + index);
			if (!chartDom) {
				console.error('initChart1找不到DOM', 'MonitorQualityAnalysisChart1' + index);
				return;
			}
			this.charts1[index] = this.echarts.init(chartDom);
			let chart = this.charts1[index];
			let option = {
				tooltip: {
					trigger: 'item',
					formatter: (params) => {
						return this.$t(params.data.name.split("||")[0]) + ":" + params.data.value + "%"
					}
				},
				legend: {
					top: 'center',
					left: 'right',
					width: '70%',
					icon: "circle",
					itemWidth: 8, // 设置宽度
					itemHeight: 8, // 设置高度
					textStyle: { //图例的样式
						color: 'white'
					},
					formatter: (name) => {
						return this.$t(name.split("||")[0])
					}

				},
				series: [{

					radius: ["0%", "92%"],
					center: ['16%', '50%'],
					type: 'pie',
					left: 'center',
					width: '100%',

					label: {
						show: false,
					},
					labelLine: {
						show: false,
					},
					itemStyle: {
						// 间隔

						normal: {

							color: function (colors) {
								var colorList = [
									'#FBFF41',
									'#FFD541',
									'#FFB03A',
									'#FF8541',
									'#FF6341',
									'#FF4141'
								];
								return colorList[colors.dataIndex];
							}
						},
					}

				}]
			};

			option && this.charts1[index].setOption(option);
		},

		initChart2(index) {
			var chartDom = document.getElementById('MonitorQualityAnalysisChart2' + index);
			this.charts2[index] = this.echarts.init(chartDom);
			let option = {
				backgroundColor: null,
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						// 坐标轴指示器，坐标轴触发有效
						type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
					},
				},
				grid: {
					left: '0',
					right: '0',
					bottom: '0',
					top: '10',
					containLabel: true,
				},

				xAxis: {
					show: true,
					type: 'category',

					axisLabel: {
						width: 100,
						overflow: "breakAll",
						textStyle: {
							fontSize: 12,
							color: '#C0C4CC',
						},
						interval: 0,
					},
					axisTick: {
						show: false,
					},
					data: []
				},
				yAxis: [{
					show: true,
					type: 'value',
					min: 0,

					axisTick: {
						show: false,
					},
					axisLabel: {
						textStyle: {
							fontSize: 12,
							color: '#C0C4CC',
						},
					},
					splitLine: {
						show: true,
						lineStyle: {
							type: 'dashed',
							color: '#606672',
						},
					},
				},],
				series: [{
					name: this.$t('liangpinlv'),
					type: 'bar',
					barWidth: '8px',
					itemStyle: {
						normal: {
							color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: '#6FE5FF',
							},
							{
								offset: 1,
								color: '#1C70C6',
							},
							]),
							barBorderRadius: 4,
						},
					},
					data: [],
				},

				],
			};
			option && this.charts2[index].setOption(option);
		},

		initChart3() {
			var chartDom = document.getElementById('MonitorQualityAnalysisChart3');
			if (!chartDom) {
				console.error('initChart3找不到DOM', 'MonitorQualityAnalysisChart3');
				return;
			}
			this.chart3 = this.echarts.init(chartDom);
			let option = {
				backgroundColor: null,
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'cross',
						label: {
							backgroundColor: '#6a7985'
						}
					}
				},
				grid: {
					left: '0%',
					right: '2%',
					bottom: '0%',
					top: '5%',
					containLabel: true
				},
				xAxis: {
					type: 'category',
					boundaryGap: false,
					data: [],
					axisLabel: {
						color: '#C0C4CC',
						fontSize: 12
					},
					axisLine: {
						lineStyle: {
							color: '#606672'
						}
					},
					axisTick: {
						show: false
					}
				},
				yAxis: {
					type: 'value',
					min: 0,
					max: 100,
					axisLabel: {
						color: '#C0C4CC',
						fontSize: 12,
						formatter: '{value}%'
					},
					axisLine: {
						lineStyle: {
							color: '#606672'
						}
					},
					axisTick: {
						show: false
					},
					splitLine: {
						lineStyle: {
							type: 'dashed',
							color: '#606672'
						}
					}
				},
				series: [{
					name: this.$t('liangpinlv'),
					type: 'line',
					smooth: true,
					symbol: 'circle',
					symbolSize: 6,
					lineStyle: {
						color: '#FFC83A',
						width: 2
					},
					itemStyle: {
						color: '#FFC83A',
						borderColor: '#FFC83A',
						borderWidth: 2
					},
					areaStyle: {
						color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
							offset: 0,
							color: 'rgba(255, 200, 58, 0.3)'
						}, {
							offset: 1,
							color: 'rgba(255, 200, 58, 0.1)'
						}])
					},
					data: []
				}]
			};
			option && this.chart3.setOption(option);
		},

		resize() {
			//因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
			setTimeout(() => {
				if (!this.$refs.header) {
					return;
				}
				this.gridContainerHeight = this.store.state.router_view_height - this.$refs.header
					.offsetHeight - 34;
				this.gridRowHeihgt = (this.gridContainerHeight - 480) / 24;
				this.chartHeight = this.$refs.chart[0].offsetHeight;
				this.chartWidth = this.$refs.chart[0].offsetWidth;

				for (var i = 0; i < 3; i++) {
					if (this.charts1[i]) {
						this.charts1[i].getDom().style.height = '0px';
						this.charts1[i].resize();
					}
					if (this.charts2[i]) {
						this.charts2[i].getDom().style.height = '0px';
						this.charts2[i].resize();
					}
				}

				setTimeout(() => {
					this.chartHeight = this.$refs.chart[0].offsetHeight;
					this.chartWidth = this.$refs.chart[0].offsetWidth;
					setTimeout(() => {
						for (var i = 0; i < 3; i++) {
							if (this.charts1[i]) {
								this.charts1[i].getDom().style.height = this.chartHeight +
									'px';
								this.charts1[i].resize();
							}
							if (this.charts2[i]) {
								this.charts2[i].getDom().style.height = this.chartHeight +
									'px';
								this.charts2[i].resize();
							}
						}


						// 处理年度良品率折线图
						if (this.chart3) {
							let chart3Height = this.$refs.chart3.offsetHeight;
							this.chart3.getDom().style.height = chart3Height +
								'px';
							this.chart3.resize();
						}

					}, 300);

				}, 500);

			}, 500);
		}
	}
};
</script>
